import React, { forwardRef, useMemo } from "react";
import classNames from "classnames";
import PdpTopActions from "./elements/pdp-top-actions";
import useNoRtl from "../hooks/use-no-rtl";
import { formatPrice } from "../utility/prices";

const ProductDetailTop = forwardRef(
  (
    { data, productTitle, priceData, scrolled, siteMetadata, location, style, storeLink, hasTabs },
    ref
  ) => {
    const { productCode } = data;

    const contributoRaee = useMemo(
      () =>
        priceData?.contributo_raee
          ? formatPrice(
              priceData.contributo_raee,
              priceData.sellingPrice.currency,
              siteMetadata.priceLanguage
            )
          : null,
      [priceData, siteMetadata.priceLanguage]
    );

    const noRtl = useNoRtl("pdp");

    return (
      <div
        style={style}
        ref={ref}
        className={classNames("product-detail__sticky", {
          "invisible": !scrolled,
          "product-detail__sticky--tabs": hasTabs,
        })}
      >
        <div className="d-md-flex justify-content-md-between align-items-md-end">
          <div>
            <div className="d-flex flex-column">
              <div className="product-detail__code order-md-2">{productCode}</div>
              <div
                className="product-detail__title order-md-1"
                dangerouslySetInnerHTML={{ __html: productTitle }}
              ></div>
            </div>
          </div>
          {!noRtl && (
            <div>
              <div className="d-flex flex-column flex-md-row align-items-center">
                <PdpTopActions
                  data={data}
                  priceData={priceData}
                  contributoRaee={contributoRaee}
                  location={location}
                  storeLink={storeLink}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default ProductDetailTop;
